<template>
  <footer class="site-footer">
    <div class="content-max-width">
      <div class="footer-links">
        <div class="top flex justify-between">
          <ul class="links">
            <li><a :href="'tel:' + nav_phone_value">{{nav_phone}}</a></li>
            <li><a :href="'tel:' + nav_mobile">{{ nav_mobile }}</a></li>
            <li><a :href="'tel:' + nav_mobile_alt">{{ nav_mobile_alt }}</a></li>
          </ul>
          <ul class="links">
            <li v-html="work_hours"></li>
            <li><a :href="'mailto:' + nav_email">{{ nav_email }}</a></li>
          </ul>
          <ul class="links">
            <li v-html="address"></li>
          </ul>
        </div>
        <div class="bottom md:flex md:justify-between">
          <ul class="links">
            <li><a href="/for-individuals">FOR INDIVIDUALS</a></li>
            <li><a href="/employ-migrants">EMPLOY MIGRANTS</a></li>
            <li><a href="/for-educators">FOR EDUCATORS</a></li>
            <li><a href="/border-exemptions">BORDER EXEMPTIONS</a></li>
          </ul>
          <ul class="links">
            <li><a href="/planning-your-trip">PLANNING YOUR TRIP</a></li>
            <li><a href="/living-in-new-zealand">LIVING IN NEW ZEALAND</a></li>
            <li><a href="/immigration-news">IMMIGRATION NEWS</a></li>
            <li><a href="/about-us">ABOUT US</a></li>
          </ul>
          <ul class="links">
            <li><a href="/our-people">OUR PEOPLE</a></li>
            <li v-if="terms_enabled"><a href="/terms-conditions">TERMS & CONDITIONS</a></li>
            <li v-if="privacy_enabled"><a href="/privacy-policy">PRIVACY POLICY</a></li>
            <li><a href="/contact-us">CONTACT US</a></li>
          </ul>
        </div>
      </div>
      <div class="cta">
        <div class="icons flex">
          <a :href="facebook" target="_blank">
            <img src="/images/icons/fb.svg" alt="Aims Facebook" />
          </a>
          <a :href="instagram" target="_blank">
            <img src="/images/icons/instagram.svg" alt="Aims Instagram" />
          </a>
          <a :href="linkedin" target="_blank">
            <img src="/images/icons/linkedin.svg" alt="Aims Linkedin" />
          </a>
          <a :href="youtube" target="_blank">
            <img src="/images/icons/youtube.svg" alt="Aims Youtube" />
          </a>
        </div>
        <button
          class="button"
          @click="$parent.isNewsletterOpen = true"
        >
          Subscribe to immigration news
        </button>

      </div>
      <div class="footer-legal flex">
        <p class="copyright">© Aims Global 2021</p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
          class="attribution"
          >Web design by Brownpaperbag</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    props: ['facebook', 'instagram', 'linkedin', 'youtube', 'address', 'work_hours', 'nav_phone', 'nav_phone_value', 'nav_mobile', 'nav_mobile_alt', 'nav_email', 'terms_enabled', 'privacy_enabled'],
    mounted() {
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue